import type { ItemVariant, POSItem } from '@/types';

export function getItemPrice(
  item: POSItem,
  customerType: string,
  variant?: ItemVariant,
): number {
  if (variant) {
    if (customerType === 'Wholesale') {
      if (variant.wholesale_price != null && variant.wholesale_price > 0) {
        return variant.wholesale_price;
      }
      if (variant.reseller_price != null && variant.reseller_price > 0) {
        return variant.reseller_price;
      }
    }
    if (customerType === 'Distributor' && variant.reseller_price != null && variant.reseller_price > 0) {
      return variant.reseller_price;
    }
    return variant.price;
  }

  if (customerType === 'Wholesale') {
    if (item.wholesale_price != null && item.wholesale_price > 0) {
      return item.wholesale_price;
    }
    if (item.reseller_price != null && item.reseller_price > 0) {
      return item.reseller_price;
    }
  }
  if (customerType === 'Distributor' && item.reseller_price != null && item.reseller_price > 0) {
    return item.reseller_price;
  }
  return item.sale_price;
}

export function getLowestVariantPrice(item: POSItem, customerType: string): number {
  const variants = item.variants || [];
  if (variants.length === 0) {
    return getItemPrice(item, customerType);
  }
  let lowest = Infinity;
  for (const v of variants) {
    const price = getItemPrice(item, customerType, v);
    if (price < lowest) lowest = price;
  }
  return lowest === Infinity ? 0 : lowest;
}
